import {handicaddieAsyncThunk} from "../../asyncThunk";
import {LoadClubCaddiesActionResponse} from "./slice";
import {ClubCaddieService} from "../../../api/ClubCaddieService";
import {ReviewService} from "../../../api/ReviewService";
import {Club} from "../../../api/ClubService";

export const loadClubCaddies = handicaddieAsyncThunk(
    "PostRound/loadClubCaddies", async (_, thunkAPI): Promise<LoadClubCaddiesActionResponse> => {
        let selectedClub: Club | undefined = thunkAPI.getState().clubs.selectedClub;
        if (!selectedClub) {
            return {
                caddies: []
            };
        }

        let caddieId: string | undefined = thunkAPI.getState().postRound.urlParams.caddieId;

        let r = await ClubCaddieService().getAllCaddies(selectedClub.id)
        let caddies = r.caddies ?? []
        let filteredCaddies = caddieId ?
            caddies.filter(c => c.caddieId === caddieId) :
            undefined

        return {
            caddies: caddies,
            filteredCaddies: filteredCaddies
        }
    }
);

export const submitReview = handicaddieAsyncThunk("PostRound/submitReview", async (_, thunkAPI): Promise<string | undefined> => {
    let session = thunkAPI.getState().postRound.session

    if (!session || !session.review) {
        return "Unable to detect your review."
    }

    let { caddie } = session
    let { message, attributes, rating, shareComment } = session.review
    let { user } = thunkAPI.getState().session

    if (!caddie?.id) {
        return "Unable to detect caddie to be reviewed."
    }
    if (!user?.id) {
        return "Unable to detect user submitting the review."
    }

    let review = {
        message: message,
        rating: rating,
        shareMessageWithCaddie: shareComment,
        attributes: attributes,
        associations: [
            {
                "associationId": caddie.id,
                "associationType": "CADDIE"
            },
            {
                "associationId": user.id,
                "associationType": "PLAYER"
            },
        ]
    }

    let resp = await ReviewService().createReview(review);
    if (resp.review) {
        return;
    }

    if (resp.error) {
        return resp.error.message
    }

    return "Something went wrong.";
});